import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useModal } from 'mui-modal-provider';

import { Button } from '../../../common/button-new';
import { VideoModal } from '../video-modal';

export interface VideoButtonProps {
  mobileVideoSrc: string;
  desktopVideoSrc: string;
  label: string;
  imgSrc: string;
  imgClasses?: string;
  videoId?: string;
  rootClasses?: string;
  ariaLabel?: string;
  testId?: string;
  hideText?: boolean;
}

export const VideoButton = ({
  mobileVideoSrc,
  desktopVideoSrc,
  label,
  imgSrc,
  imgClasses,
  videoId,
  rootClasses,
  ariaLabel,
  testId,
  hideText = false,
}: VideoButtonProps): JSX.Element => {
  const { showModal } = useModal();

  const handleClick = useCallback(() => {
    showModal(VideoModal, {
      mobileVideoSrc,
      desktopVideoSrc,
      videoId: videoId || `neuro-video-${label}`,
    });
  }, [desktopVideoSrc, mobileVideoSrc, label, showModal]);

  return (
    <Button
      rootClasses={rootClasses}
      type="button"
      onClick={handleClick}
      style="text"
      startIcon={<img className={imgClasses} src={imgSrc} alt="" />}
      hideText={hideText}
      ariaLabel={ariaLabel}
      testId={testId || `video-button-${label}`}
    >
      <FormattedMessage id={`neuro.${label}`} />
    </Button>
  );
};